import {getDataWithPromise, Globals, handleAjaxError} from "root/DataFunctions/BaseDataFns";

export const getOrganisations = (onCompleteFunc) => {

    const url = Globals.APIFolder + '/organisation' ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getOrganisationDetails = ( organisation_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/organisation/' + organisation_id ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const updateOrganisationDetails = ( organisation_id, formData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/organisation/' + organisation_id ;

    getDataWithPromise(url, 'PUT', formData).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const createNewOrganisation = ( formData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/organisation' ;

    getDataWithPromise(url, 'POST', formData).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}
